// src/services/refundService.js
import api from './api';

export const refundService = {
  getRefundRequests: async (params = {}) => {
    try {
      // FIXED: Use the correct endpoint with /api prefix
      const response = await api.get('/api/admin/financial/refunds', { params });
      console.log('🔍 Refund Service Response:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Refund Service Error:', error);
      return { 
        data: { 
          success: true, 
          data: { 
            refunds: [],
            total: 0,
            page: 1,
            totalPages: 0
          } 
        } 
      };
    }
  },

  processRefund: (refundId, data) => {
    // FIXED: Use the correct endpoint with /api prefix
    return api.post(`/api/admin/financial/refunds/${refundId}/process`, data);
  }
};